<template>
  <base-dialog v-model="show" @close="close" :loading="loading">
    <template v-slot:title>Tạo đường dẫn </template>
    <v-form ref="form" v-model="valid">
      <div v-for="item in form.compulsoty" :key="item.label">
        <field-group
          v-if="item.inputType == 'v-select'"
          :rules="item.rules"
          :label="item.label"
          :items="item.items"
          :item-text="item.display"
          :item-value="item.value"
          v-model="item.model"
          type-input="v-select"
          lazy-validation
        ></field-group>
        <field-group
          v-else-if="item.inputType == 'number'"
          :rules="item.rules"
          :label="item.label"
          v-model="item.model"
          type-input="number"
          lazy-validation
        ></field-group>
        <field-group
          v-if="item.inputType == 'v-text-field'"
          type-input="v-text-field"
          :label="item.label"
          :placeholder="item.placeholder"
          disabled
        ></field-group>
      </div>
      <div v-if="shouldShowExtraOptionsText()" class="text-h6 ml-n2 mb-4">
        Thông tin bổ sung
      </div>
      <div v-for="item in form.options" :key="item.label">
        <div
          v-if="shouldShowExtraOptions(item.requiredFor) && item.requireValue"
        >
          <field-group
            v-if="item.inputType == 'v-select'"
            :rules="item.rules"
            :label="item.label"
            :items="item.items"
            :item-text="item.display"
            :item-value="item.value"
            :loading="item.loading"
            v-model="item.model"
            type-input="v-select"
          ></field-group>
          <field-group
            v-else
            :rules="item.rules"
            :label="item.label"
            v-model="item.model"
            :type-input="item.inputType"
          ></field-group>
        </div>
      </div>
    </v-form>
    <div v-if="urlGenerate && valid">
      <div class="text-h6 ml-n2 mb-3">Kết quả</div>
      <div class="w-100">
        <field-group
          type-input="v-textarea"
          label="URL"
          v-model="urlGenerate"
          background-color="grey lighten-2"
          color="cyan"
        ></field-group>
      </div>
      <div class="text-right icon-container">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="blue-grey"
              x-small
              class="white--text copy-icon"
              fab
              @click="copyToClipBoard(urlGenerate)"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon size="15">mdi-content-copy</v-icon>
            </v-btn>
          </template>
          <span>Sao chép đường dẫn</span>
        </v-tooltip>
      </div>
    </div>
    <template v-slot:extra-btn>
      <base-button color="primary" @click="onGenerateUrl" :disabled="!valid">
        Tạo đường dẫn
      </base-button>
    </template>
    <v-snackbar v-model="snackbar" color="success">
      Sao chép thành công
      <template v-slot:action="{ attrs }">
        <v-btn
          color="danger"
          text
          v-bind="attrs"
          @click="snackbar = false"
          x-small
          fab
        >
          <v-icon>mdi-close-circle</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </base-dialog>
</template>

<script>
import { getGeoServerUrl, getCurrentUrl } from '@constant'
import { API_LAYER } from '@api'
import { cloneDeep } from 'lodash'
export default {
  props: {
    workspace: { type: Object, required: true },
    wid: Number,
  },
  data: (vm) => ({
    snackbar: false,
    filter: {
      workspace_id: '',
      is_publish: true,
    },
    valid: false,
    show: false,
    loading: false,
    key_form: null,
    form: {},
    initForm: {
      compulsoty: {
        service: {
          model: '',
          items: [
            { display: 'WMS', value: 'wms' },
            { display: 'WFS', value: 'wfs' },
          ],
          loading: false,
          display: 'display',
          value: 'value',
          label: 'Dịch vụ',
          inputType: 'v-select',
          rules: [(value) => !!value || 'Không được để trống.'],
        },
        workspace: {
          model: '',
          items: [],
          loading: false,
          display: 'name',
          value: 'id',
          label: 'Không gian làm việc',
          placeholder: '',
          inputType: 'v-select',
          rules: [(value) => !!value || 'Không được để trống.'],
        },
        version: {
          model: '',
          items: [],
          loading: false,
          display: 'display',
          value: 'value',
          label: 'Phiên bản',
          inputType: 'v-select',
          rules: [(value) => !!value || 'Không được để trống.'],
        },
        request: {
          model: '',
          items: [],
          loading: false,
          display: 'display',
          value: 'value',
          label: 'Yêu cầu',
          inputType: 'v-select',
          rules: [(value) => !!value || 'Không được để trống.'],
        },
      },
      options: {
        layers: {
          model: '',
          items: [],
          loading: false,
          display: 'name',
          value: 'urlDisplay',
          label: 'Lớp bản đồ',
          inputType: 'v-select',
          requireValue: true,
          requiredFor: ['GetMap', 'GetLegendGraphic', 'GetFeatureInfo'],
          rules: [(value) => !!value || 'Không được để trống.'],
        },
        typeNames: {
          model: '',
          items: [],
          requireValue: true,
          loading: false,
          label: 'Lớp bản đồ (typeNames)',
          inputType: 'v-select',
          display: 'name',
          value: 'urlDisplay',
          requiredFor: ['DescribeFeatureType', 'GetFeature'],
          rules: [(value) => !!value || 'Không được để trống.'],
        },
        typeName: {
          model: '',
          items: [],
          requireValue: true,
          loading: false,
          label: 'Lớp bản đồ (typeName)',
          inputType: 'v-select',
          display: 'name',
          value: 'urlDisplay',
          requiredFor: ['LockFeature'],
          rules: [(value) => !!value || 'Không được để trống.'],
        },
        bbox: {
          model: '-180,-90,180,90',
          loading: false,
          label: 'BBOX (dạng "minx,miny,maxx,maxy")',
          inputType: 'v-text-field',
          requiredFor: ['GetMap', 'GetFeatureInfo'],
          requireValue: true,
        },
        width: {
          model: '0',
          loading: false,
          label: 'Rộng',
          inputType: 'number',
          requiredFor: ['GetMap', 'GetFeatureInfo'],
          requireValue: true,
          rules: [
            (value) => (value && value >= 0) || 'Giá trị cần là số dương',
          ],
        },
        height: {
          model: '0',
          loading: false,
          label: 'Cao',
          inputType: 'number',
          requiredFor: ['GetMap', 'GetFeatureInfo'],
          requireValue: true,
          rules: [
            (value) => (value && value >= 0) || 'Giá trị cần là số dương',
          ],
        },
        x: {
          model: '0',
          loading: false,
          label: 'X',
          inputType: 'number',
          requiredFor: ['GetFeatureInfo'],
          requireValue: true,
          rules: [
            (value) => (value && value >= 0) || 'Giá trị cần là số dương',
          ],
        },
        y: {
          model: '0',
          loading: false,
          label: 'Y',
          inputType: 'number',
          requiredFor: ['GetFeatureInfo'],
          requireValue: true,
          rules: [
            (value) => (value && value >= 0) || 'Giá trị cần là số dương',
          ],
        },
        format: {
          model: '',
          items: [
            { display: 'image/png', value: 'image%2Fpng' },
            { display: 'image/jpeg', value: 'image2%Fjpeg' },
            { display: 'image/png8', value: 'image2%Fpng8' },
            { display: 'image/vnd.jpeg-png', value: 'image/vnd.jpeg-png' },
          ],
          requireValue: true,
          loading: false,
          display: 'display',
          value: 'value',
          label: 'Format',
          inputType: 'v-select',
          requiredFor: ['GetMap', 'GetLegendGraphic'],
        },
        srs: {
          model: '',
          requiredFor: ['GetMap', 'GetFeatureInfo'],
          requireValue: true,
          label: 'Hệ quy chiếu (srs)',
          inputType: 'v-text-field',
        },
        styel: {
          model: '',
          requireValue: true,
          label: 'Styles',
          requiredFor: ['GetMap', 'GetFeatureInfo'],
          inputType: 'v-text-field',
        },
        query_layers: {
          model: '',
          requireValue: true,
          label: 'Query layers',
          requiredFor: ['GetFeatureInfo'],
          inputType: 'v-text-field',
        },
        legend_options: {
          model: '',
          requireValue: true,
          label: 'Tùy chọn legend',
          requiredFor: ['GetLegendGraphic'],
          inputType: 'v-text-field',
        },
      },
    },
    itemsWS: [],
    itemsLayer: [],
    itemsVersion: [
      { display: '1.0.0', value: '1.0.0', supportedService: ['wms', 'wfs'] },
      { display: '1.1.0', value: '1.1.0', supportedService: ['wms', 'wfs'] },
      { display: '1.1.1', value: '1.1.1', supportedService: ['wms'] },
      { display: '1.3.0', value: '1.3.0', supportedService: ['wms'] },
    ],
    initItemsRequest: [
      {
        display: 'GetCapabilities',
        value: 'GetCapabilities',
        supportedService: ['wfs', 'wms'],
      },
      {
        display: 'DescribeFeatureType',
        value: 'DescribeFeatureType',
        supportedService: ['wfs'],
      },
      {
        display: 'GetFeature',
        value: 'GetFeature',
        supportedService: ['wfs'],
      },
      {
        display: 'GetFeatureInfo',
        value: 'GetFeatureInfo',
        supportedService: ['wms'],
      },
      {
        display: 'GetMap',
        value: 'GetMap',
        supportedService: ['wms'],
      },
      {
        display: 'GetLegendGraphic',
        value: 'GetLegendGraphic',
        supportedService: ['wms'],
      },
    ],
    urlGenerate: '',
  }),
  computed: {
    canSelectWorkspace() {
      return this.c_workspaces.length > 1
    },
    c_workspaces() {
      if (!this.key_form) return []
      return this.workspace.items.filter((x) =>
        this.key_form.workspace_ids.includes(x.id)
      )
    },
  },
  watch: {
    form: {
      handler() {
        this.resetUrl()
      },
      deep: true,
    },
    'form.compulsoty.request.model'(newValue) {
      for (let item in this.form.options) {
        if (this.form.options[item].inputType == 'number') {
          this.form.options[item].model = '0'
        } else {
          this.form.options[item].model = ''
        }
      }
    },
    'form.compulsoty.service.model'(newValue) {
      let filterstring = 'enable_setting_wms'
      if (newValue == 'wms') {
        filterstring = 'enable_setting_wms'
      } else if (newValue == 'wfs') {
        filterstring = 'enable_setting_wfs'
      } else {
        return
      }

      this.form.compulsoty.request.items = this.initItemsRequest.filter((x) =>
        x.supportedService.includes(newValue)
      )
      this.form.compulsoty.version.items = this.itemsVersion.filter((x) =>
        x.supportedService.includes(newValue)
      )
      if (
        !this.form.compulsoty.version.items.includes(
          this.itemsVersion.find(
            (x) => x.value == this.form.compulsoty.version.model
          )
        )
      ) {
        this.form.compulsoty.version.model = ''
      }
      if (
        !this.form.compulsoty.workspace.items.includes(
          this.key_form.workspaces.find(
            (x) => x.id == this.form.compulsoty.workspace.model
          )
        )
      ) {
        this.form.compulsoty.workspace.model = ''
      }
      if (
        !this.form.compulsoty.request.items.includes(
          this.initItemsRequest.find(
            (x) => x.value == this.form.compulsoty.request.model
          )
        )
      ) {
        this.form.compulsoty.request.model = ''
      }
    },
    valid(newValue) {
      this.urlGenerate = ''
    },
    'form.compulsoty.workspace.model'(newValue) {
      if (newValue === '') {
        return
      }
      this.filter.workspace_id = newValue
      let selectedWorkspace = this.form.compulsoty.workspace.items.find(
        (x) => x.id === newValue
      )
      if (!selectedWorkspace) {
        return
      }
      this.form.options.layers.loading = true
      this.form.options.typeNames.loading = true
      this.form.options.typeName.loading = true
      API_LAYER.list(this.filter)
        .then((res) => {
          for (let item in res.data) {
            res.data[item].urlDisplay =
              selectedWorkspace.name_geoserver +
              ':' +
              res.data[item].name_geoserver
          }
          this.form.options.layers.items = res.data
          this.form.options.typeNames.items = res.data
          this.form.options.typeName.items = res.data
        })
        .finally(() => {
          this.form.options.layers.loading = false
          this.form.options.typeName.loading = false
          this.form.options.typeNames.loading = false
          this.form.options.layers.model = ''
          this.form.options.typeName.model = ''
          this.form.options.typeNames.model = ''
        })
    },
    'form.options.layers.model'(newValue) {
      if (newValue) {
        let currentLayer = this.form.options.layers.items.find(
          (x) => x.urlDisplay == newValue
        )
        if (!currentLayer) {
          return
        }
        this.form.options.bbox.model = currentLayer.bounds
      } else {
        this.form.options.bbox.model = ''
      }
    },
  },
  methods: {
    open(data) {
      this.show = true
      this.loading = true
      this.form = cloneDeep(this.initForm)
      this.key_form = data
      this.form.compulsoty.workspace.items = this.key_form.workspaces
      if (this.wid) {
        this.form.compulsoty.workspace.items = [
          this.form.compulsoty.workspace.items.find((x) => x.id == this.wid),
        ]
      }

      if (this.form.compulsoty.workspace.items.length == 1) {
        this.form.compulsoty.workspace.inputType = 'v-text-field'
        this.form.compulsoty.workspace.placeholder =
          this.form.compulsoty.workspace.items[0].name
        this.form.compulsoty.workspace.model =
          this.form.compulsoty.workspace.items[0].id
      }
      this.form.compulsoty.request.items = this.initItemsRequest
      this.form.compulsoty.version.items = this.itemsVersion
      this.loading = false
    },
    close() {
      this.show = false
      this.loading = false
      this.key_form = null
      this.form = cloneDeep(this.initForm)
      this.$refs.form.reset()
      this.$refs.form.resetValidation()
      this.urlGenerate = ''
    },
    shouldShowExtraOptions(requiredArray) {
      if (this.form.compulsoty) {
        if (requiredArray.includes(this.form.compulsoty.request.model)) {
          return true
        }
      }
      return false
    },
    shouldShowExtraOptionsText() {
      for (let item in this.form.options) {
        if (
          this.shouldShowExtraOptions(this.form.options[item].requiredFor) &&
          this.form.options[item].requireValue
        ) {
          return true
        }
      }
      return false
    },
    resetUrl() {
      this.urlGenerate = ''
    },
    copyToClipBoard(url) {
      navigator.clipboard.writeText(url)
      this.snackbar = true
      setTimeout(() => {
        this.snackbar = false
      }, 1000)
    },
    onGenerateUrl() {
      this.$refs.form.validate()
      let selectedWorkspace = {}
      if (this.form.compulsoty.workspace.model) {
        selectedWorkspace = this.form.compulsoty.workspace.items.find(
          (x) => x.id == this.form.compulsoty.workspace.model
        )
      }
      if (Object.keys(selectedWorkspace).length === 0) {
        selectedWorkspace = this.form.compulsoty.workspace.items.find(
          (x) => x.name == this.form.compulsoty.workspace.placeholder
        )
      }
      let baseUrl =
        getCurrentUrl() +
        '/web/' +
        selectedWorkspace.name_geoserver +
        '/' +
        this.form.compulsoty.service.model +
        '?service=' +
        this.form.compulsoty.service.model +
        '&version=' +
        this.form.compulsoty.version.model +
        '&request=' +
        this.form.compulsoty.request.model +
        '&'
      let optionURL = ''
      for (let item in this.form.options) {
        if (
          this.form.options[item].requiredFor.includes(
            this.form.compulsoty.request.model
          )
        ) {
          optionURL += item + '=' + this.form.options[item].model + '&'
        }
      }
      let URL = baseUrl + optionURL
      this.urlGenerate = URL + 'key=' + this.key_form.key + '&'
    },
  },
}
</script>

<style scoped>
.copy-icon {
  transform: translateY(-60px);
  margin-right: 6px;
}
.icon-container {
  height: 0px;
  margin: 0px;
}
</style>
